<!-- eslint-disable max-len -->
<template>
  <div>
    <!-- BADGES -->
    <section>
      <b-row>
        <div class="col-2">
          <div class="left-content">
            <p class="xxs bold text-right">
              CARDS
            </p>
          </div>
        </div>
        <div class="col-10 bg-pale-grey-two">
          <div class="right-content">
            <b-row>
              <div class="col-10">
                <h2>Applicant card</h2>
              </div>
            </b-row>
            <b-row>
              <div class="col-8">
                <a href="javascript:;"
                   target="_blank"
                >
                  <div class="wide-card p-16 mt-3">
                    <div class="left-block">
                      <b-form-checkbox id="checkbox10"
                                       class="checkbox-2"
                                       value="accepted"
                      />
                      <b-img src="https://lorempixel.com/125/125/technics/8/"
                             rounded="circle"
                             width="67"
                             height="67"
                             blank-color="#777"
                      />
                    </div>
                    <div class="info">
                      <div class="info-block">
                        <span class="lg">
                          <b>Lily Wagner,</b> 38</span>
                        <span class="badge badge-tangerine xxs ml-2 bg-color-white-three text-color-dusk mr-2">İSTANBUL (AVR.)</span>
                        <!-- <i class="icon-executive mr-2"></i> -->
                        <i class="icon-disabled" />
                      </div>
                      <div class="xs d-block pt-1">
                        <b>Süreç / Proses Uzmanı</b> Funlab Eğlence Dünyası Cevahir</div>
                      <div class="xs d-block pt-1">
                        <b>Makine - Resim - Konstrüksiyon (Mezun)</b> Sakarya Üniversitesi</div>
                    </div>
                    <div class="right-block">
                      <span class="badge badge-rounded float-right">+ 3</span>
                    </div>
                  </div>
                </a>

                <!-- <div class="wide-card p-16 mt-3">
                                    <b-row>
                                        <div class="col-10">
                                            <div class="text-center d-inline float-left mr-16">
                                                <b-form-checkbox class="checkbox-2" id="checkbox10" value="accepted"></b-form-checkbox>
                                                <b-img src="https://lorempixel.com/125/125/technics/8/" rounded="circle" width="72" height="72" blank-color="#777" />
                                            </div>

                                            <div class="info">
                                                <span class="dot red mr-2"></span>
                                                <span class="lg name mr-2">
                                                    Lily Wagner,
                                                    <span class="age">38</span>
                                                </span>
                                                <i class="icon-executive mr-2"></i>
                                                <i class="icon-disabled"></i>
                                            </div>
                                            <span class="d-block xs text-color-dusk">İstanbul(Avr.)</span>
                                            <span class="other-info xs text-color-dusk-40">
                                                <span class="bold">Süreç / Proses Uzmanı,</span> Funlab Eğlence Dünyası Cevahir
                                            </span>
                                            <span class="other-info xs text-color-dusk-40">
                                                <span class="bold">Sakarya Üniversitesi,</span> Makine - Resim - Konstrüksiyon Bölümü (Mezun)
                                            </span>
                                        </div>
                                        <div class="col-2">
                                            <span class="badge badge-rounded float-right">+ 3</span>
                                        </div>
                                    </b-row>
                                </div>
                                <div class="wide-card unread p-16 mt-3">
                                    <b-row>
                                        <div class="col-10">
                                            <div class="text-center d-inline float-left mr-16">
                                                <b-form-checkbox class="checkbox-2" id="checkbox10" value="accepted"></b-form-checkbox>
                                                <b-img src="https://lorempixel.com/125/125/technics/8/" rounded="circle" blank width="72" height="72" blank-color="#777" />
                                            </div>
                                            <div class="d-inline float-left">
                                                <div class="info">
                                                    <span class="dot red mr-2"></span>
                                                    <span class="lg name mr-2">
                                                        Lily Wagner,
                                                        <span class="age">38</span>
                                                    </span>
                                                    <i class="icon-executive mr-2"></i>
                                                    <i class="icon-disabled"></i>
                                                </div>
                                                <span class="d-block xs text-color-dusk">İstanbul(Avr.)</span>
                                                <span class="d-block xs bold text-color-dusk-40">
                                                    Süreç / Proses Uzmanı, Funlab Eğlence Dünyası Cevahir
                                                </span>
                                                <span class="d-block xs text-color-dusk-40">
                                                    Sakarya Üniversitesi, Makine - Resim - Konstrüksiyon Bölümü (Mezun)
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-2">
                                            <span class="badge badge-rounded float-right">+ 3</span>
                                        </div>
                                    </b-row>
                                </div> -->
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-10">
                <h2>Advert card</h2>
              </div>
            </b-row>
            <b-row>
              <div class="col-8">
                <div class="wide-card job-card">
                  <b-row class="align-items-center info">
                    <div class="col-12">
                      <span class="dot bg-color-dark-mint mr-1 d-inline-block d-md-none align-middle" />
                      <i class="icon-lightning slot-icon pr-1" /> Slot İlan
                      <span class="xxs text-color-dusk bold align-middle pr-1">SLOT İLAN</span>
                      <span class="xxs text-color-dusk-40 bold align-middle pr-1">RF-KI21880</span>
                      <span class="xxs text-color-warm-grey bold align-middle pr-1 d-inline-block d-md-none">17 Ağustos 2017</span>
                      <i v-b-tooltip.hover.top="'Engelli İlanı!'"
                         class="icon-disabled disable-icon align-middle pr-1"
                      />
                    </div>
                    <b-col cols="12">
                      <b-row align-v="center">
                        <div class="col-12">
                          <h2 class="bold align-middle">
                            GARSON
                          </h2>
                        </div>
                      </b-row>
                    </b-col>
                    <b-col cols="12"
                           class="d-none d-md-block"
                    >
                      <span class="dot bg-color-dark-mint mr-1" />
                      <span class="xs bold text-color-dusk-40 ">AKTİF</span>
                      <i class="ml-2 mr-0 align-middle" />
                      <i id="exButton2"
                         class="icon-question-mark slot"
                      />
                      <b-tooltip target="exButton2"
                                 placement="top"
                      >
                        <div class="xs">
                          Son güncelleme: 12 Mart 2018
                        </div>
                        <div class="xs">
                          Kapanma tarihi: 06 Mayıs 2018
                        </div>
                      </b-tooltip>
                      <span class="xs purple">
                        <b>17 Ağustos 2017</b>'de yayınlandı</span>
                    </b-col>
                  </b-row>
                  <div class="counts">
                    <div class="wrapper">
                      <b-row>
                        <b-col cols="4">
                          <h2 class="bold mb-0">
                            234
                          </h2>
                          <span class="xxs text-color-dusk-40 bold d-block">GÖRÜNTÜLEME</span>
                        </b-col>
                        <b-col cols="4">
                          <h2 class="bold mb-0">
                            82
                          </h2>
                          <span class="xxs text-color-dusk-40 bold d-block position-relative text-uppercase">BAŞVURU
                            <div class="mt-1 position-absolute w-100 text-center">
                              <span class="pl-1 pr-1 bg-color-purple text-color-white rounded d-none d-md-inline-block">5 Yeni</span>
                            </div>
                          </span>
                        </b-col>
                        <b-col cols="4">
                          <h2 class="bold mb-0">
                            7
                          </h2>
                          <span class="xxs text-color-dusk-40 bold d-block">FAVORİ ADAY</span>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                  <div class="options">
                    <div class="wrapper">
                      <b-row>
                        <b-col>
                          <div class="text-right">
                            <b-dd id="ddown-sm-split"
                                  size="md"
                                  split
                                  class="sensitive border-traid"
                            >
                              <template slot="button-content">
                                <i /> İlanı Düzenle
                              </template>
                              <b-dd-item-btn>Action</b-dd-item-btn>
                              <b-dd-item-btn>Another action</b-dd-item-btn>
                              <b-dd-item-btn>Something else here...</b-dd-item-btn>
                            </b-dd>
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </div>
              </div>
            </b-row>
          </div>
        </div>
      </b-row>
    </section>
  </div>
</template>
<script>
export default {
  name: 'Card',
  data() {
    return {};
  },
  computed: {},
};
</script>
